module.exports = __webpack_public_path__ + "img/photo-49.cd1bb142.webp";